"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanRecordDetailRequest = void 0;
var LoanRecordDetailRequest = /** @class */ (function () {
    function LoanRecordDetailRequest() {
        this.loanNo = '';
    }
    return LoanRecordDetailRequest;
}());
exports.LoanRecordDetailRequest = LoanRecordDetailRequest;
//# sourceMappingURL=loanRecordDetail.request.js.map